module Meevo.Plugins.Egifts {

    import EGiftTemplateCatEnum = Meevo.Model.EGiftTemplateCatEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import LocationOverride = Meevo.Model.LocationOverride;
    import CommunicationTypeUserEnum = Meevo.Model.CommunicationTypeUserEnum;
    import LevelSettingEnum = Meevo.Model.LevelSettingEnum;
    import IAuditLog = Meevo.Model.IAuditLog;
    import SortDirection = Meevo.Model.SortDirection;
    import CoSearchType = Meevo.Model.CoSearchType;
    import SaleStateEnum = Meevo.Model.SaleStateEnum;
    import BOGOBasedOnTypeEnum = Meevo.Model.BOGOBasedOnTypeEnum;
    import NotificationTags = Meevo.Components.Common.NotificationTags;

    export namespace EgiftCardTemplates {
        export interface INewTemplate {
            eGiftTemplateCatEnum: null,
            eGiftTemplateTypeEnum: null,
            id: null,
            objectStateEnum: ObjectStateEnum,
            templateName: null,
            isGiftCard: boolean
        };
    }

    export namespace EgiftMainSection {
        export interface IGetMerchantAccountsReq {
            criteria: {
                coSearchType: number;
                coFilterByLocationId: number;
            }
        }

        export interface IGetLocationReq {
            criteria: {
                filterBySessionUser: boolean;
            }
        }

        export interface IGetTemplateListReq {
            criteria: {
                templateName?: string;
                eGiftTemplateCategoryEnum?: null;
                eGiftTemplateTypeEnum?: number;
                isGiftCard?: boolean;
            }
        }

        export interface IEgiftLocationItem {
            tenantId?: number;
            address1: string;
            billDay: number;
            city: string;
            conversionType: number;
            countryCode: string;
            customerNumber: string;
            defaultAppointmentBookColumnZoom: number;
            defaultAppointmentBookTimeZoom: number;
            defaultBusinessTypeId: string;
            defaultLanguageId: number;
            entityVersion: number;
            externalId: string;
            genderSpecificAnonClient: false
            hasEvents: false
            installationType: number;
            isTimeZoneConfirmed: true
            locationId: number;
            locationStatus: number;
            locationTimeZone: string;
            maxServiceProvidersAllowed: number;
            meevoEditionType: number;
            phoneNumber: string;
            priceGroup_TId: string;
            state: string;
            storeName: string;
            storeNumber: string;
            subDomainUrl: string;
            subscriptionActivationDate: Date;
            subscriptionStatus: number;
            zipCode: string;
        }
    }

    export namespace EgiftPromotionsSection {

        export interface IPromotionsRequest {
            criteria: {
                businessType: null,
                coBusinessTypeId: null,
                coFilterByLocationId: null,
                coSearchResultFilter: number,
                coSearchType: null | number,
                discountType: null,
                includeActive: boolean,
                includeDeleted: boolean,
                includeInactive: boolean,
                location: null,
                maintenanceMode: boolean,
                isEGift: boolean,
                isBuyGet: null,
                isCoOwned: null
            },
            itemsPerPage: number,
            sortBy: string,
            sortDirection: SortDirection,
        }

        export interface IPromotionsSection {
            create: () => void,
            reloadData: () => void;
        }

        export interface IPromotiontType {
            value: DiscountTypeEnum;
            label: string;
        }

        export interface IBogoBasedOnTypes {
            value: BOGOBasedOnTypeEnum;
            label: string;
        }

        export interface ILocationPromotionFilter {
            value: COBusinessType;
            label: string;
        }

        

        export interface ISelectedDiscounts {
            discounts: Array<IDiscount>;
        }

        export interface IDiscount {
            entityVersion?: number;
            isEGift: boolean;
            isMembershipClientDiscount?: boolean;
            isRedeemableLimitApplicable?: boolean;
            discountRedeemableLimitPerTypeEnum?: Meevo.Model.DiscountRedeemableLimitPerTypeEnum;
            promotionCode?: string;
            discountOptionEnum?: string;
            discountEntityTypeEnum: Meevo.Model.DiscountEntityTypeEnum;
            objectState: Meevo.Model.ObjectStateEnum;
            discountEntityGranularityTypeEnum: Meevo.Model.DiscountEntityGranularityTypeEnum;
            locationId: number;
            availableToLocations: boolean;
            locationOverride: LocationOverride;
            homeLocationId: number;
            isBuyGet?: boolean;
            discountTypeEnum?: DiscountTypeEnum;
        }

        export interface IEgiftDiscount extends IDiscount {
            buy_Amount?: number;
            buy_AmountMin?: number;
            buy_AmountMax?: number;
            discountAmount?: number;
            discountTypeEnum?: DiscountTypeEnum;
            discountTypeEnumGet?: DiscountTypeEnum;
            bogoBasedOnTypeEnum?: BOGOBasedOnTypeEnum;
            get_Quantity?: number;
            buy_Quantity?: number;
            isBuyGet?: boolean;
            isAllowRedeemBuyGet?: boolean;
            get_Amount?: number;
            get_AmountMin?: number;
            get_AmountMax?: number;
            eGift_WaiveProcessingFee?: boolean;
            eGift_WaiveShippingFee?: boolean;
            eGift_CombineFreeCards?: boolean;
            eGift_FreeCardIncrement?: number;
            eGift_FreeCardAmount?: number;
            promoGiftCardTypeId?: string;
        }

        export enum LocationEnum {
            Location,
            CO
        }

    }

    export namespace EgiftPackedgeSection {
        export interface IPackagesRequest {
            criteria?: IParams;
            itemsPerPage: number;
            pageNumber?: number;
            sortDirection?: SortDirection;
            sortBy?: string;
            asLocationId: number;
        }
        interface IParams {
            isAvailableAsEgift: boolean,
            objectState: Model.ObjectStateEnum,
            businessTypeId: string,
            maintenanceMode: boolean,
            isGlobal: boolean,
            coSearchType: CoSearchType,
            cOOwned: COBusinessType
        }
        export interface ISelectedPackage {
            homeLocationId?: number;
            entityVersion: number;
            isAvailableAsEgift: boolean;
            packageTypeId: string;
        }

        export interface ICoBusinessTypeList {
            label: string;
            value: COBusinessType;
        }
    }

    export namespace EgiftServicesSection {
        export interface IServicesRequest {
            criteria?: IParams;
            itemsPerPage: number;
            pageNumber?: number;
            sortDirection?: SortDirection;
            sortBy?: string;
            asLocationId: number;
        }

        interface IParams {
            isAvailableAsEgift: boolean,
            objectState: Model.ObjectStateEnum,
            businessTypeId: string,
            serviceCategoryId: string,
            priceGroupId: string,
            maintenanceMode: boolean,
            isGlobal: boolean,
            coSearchType?: CoSearchType,
            coOwned?: COBusinessType
        }

        export interface ISelectedService {
            entityVersion: number;
            isAvailableAsEgift: boolean;
            serviceId: string;
            homeLocationId: number;
        }

        export interface ILocationFilters {
            value: COBusinessType;
            label: string;
        }

    }

    export namespace EgiftTransactionsSection {
        export interface ITransactionRequest {
            criteria?: IParams;
            itemsPerPage: number;
            pageNumber?: number;
            sortDirection?: SortDirection;
            sortBy?: string;
            asLocationId: number;
        }

        export interface ITransactionMeevoPagerReq {
            sortBy: string,
            sortDirection: SortDirection
        }

        export interface IprepareesendTransactionReq {
            giftCardId: Guid,
            type: EgfitCommunicationTypeEnum,
            locationId: number
        };

        export interface ITransactionsFilterSettingsReq {
            giftCardNumber: any;
            dateFrom: Date;
            dateTo: Date;
            eMail: string;
            maintenanceMode: boolean;
            isGlobal: boolean;
            isValid: boolean;
            finalPrice: number;
            purchasedByEmail: string;
            fullNameFrom: string;
            fullNameTo: string;
            emailDeliveryStatuses: any;
            deliveryMethodsEnum: DeliveryMethodEnum;
            originalAmount: number;
            withNotes: boolean;
            locationId?: number;
            saleState: SaleStateEnum;
            isRefund?: boolean;
        }

        export interface IGiftCardAudit extends IAuditLog {
            modifiedByUserId: Guid;
            verbName: string;
        }

        export interface ITransaction {
            activeDate: Date;
            clientDisplayName: string;
            clientFirstName: string;
            eGiftId: Guid;
            clientHomeLocationId: number;
            clientHomeLocationTimeZone: string;
            clientId: Guid;
            clientLastName: string;
            clientPurchase_TId: Guid;
            dateCreated: Date;
            dateUpdated: Date;
            deliveryMethodEnum: number;
            deliveryStatusEnum: number;
            emailAddressFrom: string;
            emailAddressTo: string;
            entityVersion: number;
            finalPrice: number;
            fullNameFrom: string;
            fullNameTo: string;
            giftCardNumber: string;
            hideOriginalAmount: boolean;
            isFree: boolean;
            isHaveNotes: boolean;
            locationId: number;
            originalAmount: number;
            remainingAmount: number;
            remainingRefundAmount: number;
            saleState: number;
            templateName: string;
            template_TId: string;
            transactionId: string;
            updatedByUserId: string;
            updatedInLocationId: number;
            updatedInLocationName: string;
            userName: string;
            trackingNumber: string;
            trackingUrl: string;
            shippingFeeDisplayName: string;

            purchasedForClient: {};
            isAutoGenerateNumber: boolean;
            barCode: string;
            isUpdateNumber?: boolean
        }

        export interface INote {
            dateUpdated?: Date;
            id?: Guid;
            isEditingMode?: boolean;
            note: string;
            objectState?: Meevo.Model.ObjectStateEnum;
            userDisplayName?: string;
            asLocationId?: null
            EgiftId?: string;
        }

        export interface IDeliveryMethods {
            value: DeliveryMethodEnum | null;
            label: string;
        }

        export interface IEmailDeliveryStatuses {
            value: EgiftEmailDeliveryStatusEnum;
            label: string;
        }

        export interface IMailDeliveryStatuses {
            value: EgiftMailDeliveryStatusEnum;
            label: string;
        }

        export interface IPickupDeliveryStatuses {
            value: EgiftPickupDeliveryStatusEnum;
            label: string;
        }

        export interface IConsumMailPickupStatus {
            value: EgiftMailDeliveryStatusEnum | EgiftPickupDeliveryStatusEnum;
            label: string;
        }

        export interface ISortCategories {
            sortBy: string;
            label: string;
            sortDirection: SortDirection;
        }

        interface IParams extends ITransactionsFilterSettingsReq {
           
        }

    }

    export namespace EgiftTemplates {

        export interface ICategoryStatusOption {
            value: ObjectStateEnum;
            label: string;
        }

        interface IBaseParams {
            templateName: string | null;
            eGiftTemplateCategoryEnum: EGiftTemplateCatEnum | null;
            isEGift: boolean | null;
            isGiftCard: boolean;
            businessTypeId: string | null;
            priceGroupId: string;
            objectState: ObjectStateEnum | null;
            filter: string | null;
            maintenanceMode: boolean;
            isGlobal: boolean;
        }

        export interface IBaseTemplateReq {
            criteria: {
                eGiftTemplateTypeEnum: EGiftTemplateType;
            }
            asLocationId: number;
        }

        export interface ITemplateSectionReq {
            criteria: IBaseParams & {
                templateSupportsLogo?: boolean;
                eGiftTemplateTypeEnum?: EGiftTemplateType;

            },
            asLocationId: number,
            itemsPerPage: number
        };

        export interface ICardTemplatesSectionReq {
            criteria: IBaseParams,
            asLocationId: number,
            itemsPerPage: number
        }

        export interface INewTemplate {
            eGiftTemplateCatEnum: null,
            //eGiftTemplateTypeEnum: null,
            id: null,
            objectStateEnum: ObjectStateEnum
            templateName: null,
            templateSupportsLogo: boolean,
            isGiftCard: boolean
        };

    }

    export namespace EgiftNotificationsSection {

        export interface INotification {
            businessTypeDetail?: {};
            isAlreadyDefault?: boolean;
            languageId?: number;
            levelSetting?: LevelSettingEnum
            tenantId?: number;
            typeId?: number;
            entityVersion: number;
            communicationType?: EgfitCommunicationTypeEnum;
            communicationTypeUser?: CommunicationTypeUserEnum;
            emailBody: string | any;
            emailSubject: string;
            isDefault: boolean;
            isServiceDefault: boolean;
            objectState: ObjectStateEnum;
            displayName: string;
            id: string;
        }

        export interface IDeliveryMethods {
            value: DeliveryMethodEnum,
            communicationType: EgfitCommunicationTypeEnum,
            label: string
        }

        export interface NotificationTemplate {
            [key: number]: {
                hidden?: boolean;
                title: string;
                showFilter?: boolean;
                template?: INotification;
                templateBackup?: INotification;
                type: EgfitCommunicationTypeEnum;
                tags: NotificationTags[];
                order: number;
                filter?: any;
            }
        }

        export enum NotificationItemTypeEnum {
            GiftCard,
            Package
        }
    }

    //// shared interface ////
    export interface ICategoryTypesOption {
        value: EGiftTemplateCatEnum;
        label: string;
    }

    export interface ITemplateItem {
        eGiftTemplateCatEnum: EGiftTemplateCatEnum;
        eGiftTemplateTypeEnum: EGiftTemplateType;
        id?: Guid;
        objectStateEnum: ObjectStateEnum;
        templateName: string;
        templateSupportsLogo?: boolean;
        fileGuid?: string;
        templateMetaData?: string;
        meevoFile?: Meevo.Model.MeevoFile;
        contentType?: string;
        imageUrl?: string;
        isGiftCard?: boolean;
        isStorageUpdated?: boolean;
        resourceType?: number;
        systemFileTypeEnum?: number;
    }

    export interface IFilterByAvailableInEgift {
        value: null | boolean;
        title: string;
    }

    export interface IChargeShipping {
        chargeSelected : boolean,
        displayName: string,
        value : string | null
    }

    //// shared enums ////

    export enum EGiftTemplateType {
        CustomTemplate = 30360,
        SystemTemplate = 30361,
        GiftCardTemplate = 30546
    }

    export enum DeliveryMethodEnum {
        StorePickup = 30543,
        Mail = 30544,
        EMail = 30545
    }

    export enum ProcessingFeeTypeEnum {
        PerTransaction = 20165,
        PerGiftCard = 20166
    }

    export enum EgfitCommunicationTypeEnum {
        EgiftRecipientEmail = 30580,
        EgiftRecipientEmailPackage = 11045424,
        EgiftShippedEmail = 11045389,
        EgiftPurchaserEmail = 30581,
        EgiftLocationEmail = 30582,
        EgiftPurchaserEmailForMail = 30583,
        EgiftPurchaserEmailForPickUp = 50046,
        EgiftPurchaserEmailForReadyToPickup = 20179,
        
    }

    export enum EgiftEmailDeliveryStatusEnum {
        Sent = 10067,
        DeliveryFailed = 10068
    }

    export enum EgiftMailDeliveryStatusEnum {
        New = 10059,
        InProgress = 10060,
        ReadyToShip = 10061,
        Shipped = 10062
    }

    export enum EgiftPickupDeliveryStatusEnum {
        New = 10063,
        InProgress = 10064,
        ReadyForPickup = 10065,
        PickedUp = 10066
    }

    export enum COBusinessType {
        All = null,
        Location = 0,
        CentralOffice = 1
    }

    export enum TemplateEditStatus {
        None = 0,
        IsEditingNew = 1,
        IsEditingExisting = 2
    }
}
